import { Directive, HostListener } from '@angular/core';
import { FormToggleService } from './form-toggle.service';

@Directive({
  selector: '[labsForgotPassword]'
})
export class ForgotPasswordDirective {
  constructor(private formToggleService: FormToggleService) {}

  @HostListener('click', ['$event']) onClick(event: MouseEvent) {
    event.preventDefault();
    this.formToggleService.toggle();
  }
}
